import { inject } from '@angular/core';
import { CanActivateFn, CanMatchFn, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { Store } from '@ngrx/store';
import * as AuthSelectors from '../+state/auth.selectors';
import { map, tap } from 'rxjs/operators';
import * as AuthActions from '../+state/auth.actions';

const checkAuthStatus = ():
  | Observable<boolean | UrlTree>
  | Promise<boolean | UrlTree>
  | boolean
  | UrlTree => {
  const store = inject(Store);
  return store.select(AuthSelectors.getAuthLoggedIn).pipe(
    map((auth: boolean) => auth),
    tap((auth: boolean) => {
      if (!auth) {
        store.dispatch(AuthActions.loginRedirect());
      }
    })
  );
};

export const canActivateFn: CanActivateFn = () => {
  return checkAuthStatus();
};

export const canMatchFn: CanMatchFn = () => {
  return checkAuthStatus();
};
